export var ScheduleType;
(function (ScheduleType) {
    ScheduleType["CHECKUP"] = "CH";
    ScheduleType["CHEMOTHERAPY"] = "Q";
    ScheduleType["CONSULTATION"] = "C";
    ScheduleType["EXAM"] = "E";
    ScheduleType["REQUEST"] = "R";
    ScheduleType["SERVICE"] = "S";
    ScheduleType["SURGERY"] = "Y";
    ScheduleType["WAITING_LIST"] = "W";
})(ScheduleType || (ScheduleType = {}));
//# sourceMappingURL=pseudonym-suggestion-card-item-type.js.map